import {
  useLayoutEffect,
  useState,
  useEffect,
  useCallback,
  useRef,
} from "react";
import {
  DateBox,
  NumberBox,
  SelectBox,
  Template,
  TextArea,
  TextBox,
} from "devextreme-react";
import DataGrid, {
  Column,
  Export,
  HeaderFilter,
  Pager,
  Paging,
  Scrolling,
  SearchPanel,
} from "devextreme-react/data-grid";
import { useSelector } from "react-redux";
import { DefaultDateFormat, IconWithTooltip } from "../../../helper/fixcode";
import { assetService } from "../../../apis/apiServices/Asset";
import { useLocation } from "react-router-dom";
import "./../../../App.css";
import Modal from "react-modal";
import moment from "moment";
import { askConfirmation, showResponseMessage } from "../../../helper/message";

export default function AssetAttachmentAlertComponent() {
  const user = useSelector((state) => state.user.data);
  const location = useLocation();
  const [assetAttachment, setAssetAttachment] = useState({
    isUploaded: false,
    isSubmitted: false,
    documentTypeId: 0,
    documentTypeName: "",
    documentCategoryId: 0,
    documentCategoryName: "",
    isRenewable: false,
    haveDocumentNo: false,
    documentNo: "",
    fileName: "",
    fileUrl: "",
    fileType: "",
    fileSize: 0,
    fileData: "",
    isIssueDateEnable: false,
    issueDate: "",
    isExpiryDateEnable: false,
    expiryDate: "",
    isReminderAlertEnable: false,
    reminderAlertDays: 0,
    remark: "",
    isUploaded: false,
    uploadedTemporaryAttachmentLst: [],
    isSaveAttachmentModalOpen: false,
  });
  const [errors, setErrors] = useState({
    documentTypeValidation: "",
    fileNameValidation: "",
    documentCategoryValidation: "",
  });
  const [assetDocumentTypeDropdown, setAssetDocumentTypeDropdown] = useState(
    []
  );
  const [assetDocumentCategoryDropdown, setAssetDocumentCategoryDropdown] =
    useState([]);
  const [
    assetAttachmentAlertDataSourceLst,
    setAssetAttachmentAlertDataSourceLst,
  ] = useState([]);
  const refDataGrid = useRef(null);

  useLayoutEffect(() => {
    document.querySelector(
      "#pageTitle"
    ).innerHTML = `Asset Attachment [${location?.state?.stateData.assetSerial}]`;
  }, []);

  let isUseEffectRendered = false;
  useEffect(() => {
    const controller = new AbortController();
    try {
      if (isUseEffectRendered) {
        return;
      }
      fetchApiOnPageLoad();
      return () => {
        controller.abort();
        isUseEffectRendered = true;
      };
    } catch (error) {
      console.log(error);
    }
  }, []);

  const fetchApiOnPageLoad = useCallback(async () => {
    try {
      setTimeout(async () => {
        await getAssetAttachmentLst(location?.state?.assetId ?? 0);
      }, 0);
    } catch (error) {
      console.log(error);
    }
  }, []);

  const getAssetDocumentCategoryDropdown = async () => {
    try {
      const response = await assetService.getAssetDocumentCategoryDropdown();
      setAssetDocumentCategoryDropdown(response?.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getAssetDocumentTypeDropdown = async (documentCategoryId) => {
    try {
      const response = await assetService.getAssetDocumentTypeDropdown(
        documentCategoryId
      );
      setAssetDocumentTypeDropdown(response?.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getAssetAttachmentLst = async (assedId) => {
    try {
      refDataGrid?.current?.instance?.beginCustomLoading();
      const response = await assetService.getAssetAttachmentList(assedId);
      setAssetAttachmentAlertDataSourceLst(response.data);
    } catch (error) {
      console.log(error);
    } finally {
      refDataGrid?.current?.instance?.endCustomLoading();
    }
  };

  const isValidUploadTempAttachment = () => {
    let isValid = true;
    try {
      let err = { ...errors };
      err.documentCategoryValidation = "";
      err.documentTypeValidation = "";
      err.fileNameValidation = "";
      if (assetAttachment.documentCategoryId === 0) {
        err.fileNameValidation = "Please select document category.";
        isValid = false;
      }
      if (assetAttachment.documentTypeId === 0) {
        err.documentTypeValidation = "Please select document type.";
        isValid = false;
      }
      if (!assetAttachment.fileName) {
        err.fileNameValidation = "Please upload document.";
        isValid = false;
      }
      setErrors(err);
    } catch (error) {
      console.log(error);
    }
    return isValid;
  };

  const handleOnSaveTemporaryAttachment = async (e) => {
    e.preventDefault();
    try {
      if (isValidUploadTempAttachment()) {
        setAssetAttachment((prev) => ({ ...prev, isUploaded: true }));
        setAssetAttachment((prev) => {
          const existingList = prev.uploadedTemporaryAttachmentLst || [];
          const newAttachment = {
            noOfRows: Math.random().toString(16).slice(2),
            id: 0,
            assetId: location?.state?.assetId ?? 0,
            assetFileName: assetAttachment.fileName ?? "",
            fileSize: assetAttachment.fileSize ?? 0,
            fileTypeId: assetAttachment.documentTypeId ?? 0,
            fileTypeName: assetAttachment.documentTypeName ?? "",
            fileCategoryId: assetAttachment.documentCategoryId ?? 0,
            fileCategoryName: assetAttachment.documentCategoryName ?? "",
            fileDocumentNo: assetAttachment.documentNo ?? "",
            filePath: "",
            fileUrl: "",
            fileData: assetAttachment.fileData ?? "",
            fileType: assetAttachment.fileType ?? "",
            uploadDate: "",
            issueDate: assetAttachment.issueDate
              ? moment(assetAttachment.issueDate).format(
                  DefaultDateFormat.SqlDateFormat
                )
              : "",
            expiryDate: assetAttachment.expiryDate
              ? moment(assetAttachment.expiryDate).format(
                  DefaultDateFormat.SqlDateFormat
                )
              : "",
            reminderAlertDays: assetAttachment.reminderAlertDays ?? 0,
            remark: assetAttachment.remark ?? "",
          };
          return {
            ...prev,
            uploadedTemporaryAttachmentLst: [...existingList, newAttachment],
          };
        });
        setAssetAttachment((prev) => ({
          ...prev,
          documentTypeId: 0,
          documentTypeName: "",
          documentCategoryId: 0,
          documentCategoryName: "",
          fileName: "",
          fileUrl: "",
          fileType: "",
          fileSize: 0,
          fileData: "",
          isIssueDateEnable: false,
          issueDate: "",
          isExpiryDateEnable: false,
          expiryDate: "",
          isReminderAlertEnable: false,
          reminderAlertDays: 0,
          remark: "",
          isRenewable: false,
          haveDocumentNo: false,
          documentNo: "",
        }));
      }
    } catch (error) {
      console.log(error);
    } finally {
      setAssetAttachment((prev) => ({ ...prev, isUploaded: false }));
    }
  };

  const getBase64 = (file) => {
    if (!file) {
      return "";
    }
    return new Promise((resolve) => {
      let baseURL = "";
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        baseURL = reader.result;
        resolve(baseURL);
      };
    });
  };

  const handleOnAssetFileUpload = (e) => {
    try {
      const file = e.target.files[0];
      let err = { ...errors };
      err.fileNameValidation = "";
      setAssetAttachment((prev) => ({
        ...prev,
        fileName: file?.name ?? "",
        fileType: file?.type ?? "",
        fileSize: file?.size ?? 0,
      }));
      getBase64(file).then((result) => {
        file["base64"] = result;
        setAssetAttachment((prev) => ({ ...prev, fileData: result, file }));
      });
      setErrors(err);
    } catch (error) {
      console.log(error);
    }
  };

  const handleOnSubmitAssetAttachment = async (e) => {
    e.preventDefault();
    try {
      let confirmationQuestion = `<span style='font-size:16px;'>Are You Sure Want To Add ${
        assetAttachment.uploadedTemporaryAttachmentLst?.length === 1
          ? `${assetAttachment.uploadedTemporaryAttachmentLst?.length} Attachment`
          : `${assetAttachment.uploadedTemporaryAttachmentLst?.length} Attachments`
      } For Asset [<b>${location?.state?.stateData.name} - (${
        location?.state?.stateData.assetSerial
      })</b>]?</span>`;
      let isConfirmed = await askConfirmation(
        confirmationQuestion,
        "Yes",
        "No"
      );
      if (!isConfirmed) return;
      setAssetAttachment((prev) => ({ ...prev, isSubmitted: true }));
      let body = {
        assetId: location?.state?.assetId,
        userId: user?.userId,
        assetAttachments: assetAttachment.uploadedTemporaryAttachmentLst,
      };
      const response = await assetService.saveAssetAttachment(body);
      isConfirmed = await showResponseMessage(response);
      setAssetAttachment((prev) => ({ ...prev, isSubmitted: false }));
      if (response?.isSuccess) {
        handleOnCloseAddAssetAttachmentModal();
        await getAssetAttachmentLst(location?.state?.assetId);
      }
    } catch (error) {
      setAssetAttachment((prev) => ({ ...prev, isSubmitted: false }));
      console.log(error);
    }
  };

  const handleOnCloseAddAssetAttachmentModal = () => {
    try {
      setAssetAttachment((prev) => ({
        ...prev,
        documentTypeId: 0,
        documentTypeName: "",
        documentCategoryId: 0,
        documentCategoryName: "",
        fileName: "",
        fileUrl: "",
        fileType: "",
        fileSize: 0,
        isIssueDateEnable: false,
        issueDate: "",
        isExpiryDateEnable: false,
        expiryDate: "",
        isReminderAlertEnable: false,
        reminderAlertDays: 0,
        remark: "",
        isUploaded: false,
        uploadedTemporaryAttachmentLst: [],
        isSaveAttachmentModalOpen: false,
        isRenewable: false,
        haveDocumentNo: false,
        documentNo: "",
        fileData: "",
      }));
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div className="content">
        <div className="card">
          <div className="card-body">
            <DataGrid
              ref={refDataGrid}
              keyExpr="assetAttachmentId"
              dataSource={assetAttachmentAlertDataSourceLst}
              showColumnLines={false}
              showRowLines={true}
              showBorders={true}
              allowColumnResizing={false}
              allowColumnReordering={true}
              columnAutoWidth={true}
              onToolbarPreparing={(e) => {
                e.toolbarOptions.items.unshift(
                  {
                    location: "before",
                    template: "toolbarAddTemplate",
                  },
                  {
                    location: "before",
                    template: "toolbarRefreshTemplate",
                  },
                  {
                    location: "before",
                    template: "toolbarBackTemplate",
                  }
                );
              }}
            >
              <Column
                dataField="assetAttachmentId"
                width={`${
                  assetAttachmentAlertDataSourceLst?.filter(
                    (f) => f.isRenewable && f.statusId === 2
                  )?.length > 0
                    ? 60
                    : 20
                }`}
                caption=""
                allowExporting={false}
                allowFiltering={false}
                allowSearch={false}
                cellRender={(cellData) => {
                  const idPrefix = `icon-${cellData?.data?.assetAttachmentId}`;
                  return (
                    <>
                      <div style={{ display: "flex" }}>
                        <span>
                          <IconWithTooltip
                            id={`${idPrefix}-delete`}
                            className="iconify-size mr-1"
                            title="Delete"
                            tooltip="Delete"
                            icon="fluent:delete-32-regular"
                            style={{ cursor: "pointer" }}
                            onClick={async (e) => {
                              e.preventDefault();
                              try {
                                let confirmationQuestion = `Are You Sure Want To Delete ${cellData?.data?.assetFileName} For Asset No [${cellData?.data?.assetNo}]?`;
                                let isConfirmed = await askConfirmation(
                                  confirmationQuestion,
                                  "Yes",
                                  "No"
                                );
                                if (!isConfirmed) return;
                                const response =
                                  await assetService.deleteAssetAttachment(
                                    cellData?.data?.assetAttachmentId,
                                    cellData?.data?.assetId
                                  );
                                isConfirmed = await showResponseMessage(
                                  response
                                );
                                if (response?.isSuccess) {
                                  await getAssetAttachmentLst(
                                    location?.state?.assetId
                                  );
                                }
                              } catch (error) {
                                console.log(error);
                              }
                            }}
                          />
                        </span>
                        <span>
                          {cellData?.data?.isRenewable &&
                          cellData?.data?.statusId === 2 ? (
                            <>
                              <IconWithTooltip
                                id={`${idPrefix}-renew`}
                                className="iconify-size mr-1"
                                title="Renew"
                                tooltip="Renew"
                                icon="fluent-mdl2:renewal-current"
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  setAssetAttachment((prev) => ({
                                    ...prev,

                                    isSaveAttachmentModalOpen: true,
                                  }));
                                }}
                              />
                            </>
                          ) : (
                            ""
                          )}
                        </span>
                      </div>
                    </>
                  );
                }}
              />
              <Column
                dataField="assetName"
                caption="Asset"
                allowSearch={true}
                allowFiltering={false}
              />
              <Column
                dataField="assetNo"
                caption="Asset #"
                allowSearch={true}
                allowFiltering={false}
              />
              <Column
                dataField="assetFileName"
                caption="Asset File"
                allowSearch={true}
                allowFiltering={false}
              />
              <Column
                dataField="documentCategoryName"
                caption="Document Category"
                allowSearch={true}
                allowFiltering={false}
              />
              <Column
                dataField="documentType"
                caption="Document Type"
                allowSearch={true}
                allowFiltering={false}
              />
              <Column
                dataField="assetFileDocumentNo"
                caption="Document No"
                allowSearch={true}
                allowFiltering={false}
              />
              <Column
                dataField="activationDate"
                caption="Activation Date"
                allowSearch={true}
                allowFiltering={false}
                dataType="date"
                format={DefaultDateFormat.GridDateFormat}
              />
              <Column
                dataField="expiryDate"
                caption="Expiry Date"
                allowSearch={true}
                allowFiltering={false}
                dataType="date"
                format={DefaultDateFormat.GridDateFormat}
              />
              <Column
                dataField="daysToExpire"
                caption="Days To Expire"
                allowSearch={true}
                allowFiltering={false}
                alignment={"center"}
              />
              <Column
                dataField="status"
                caption="Status"
                allowSearch={true}
                allowFiltering={false}
              />
              <Column
                dataField="isExpiringIn30Days"
                caption="Is Expiring In 30 Days"
                allowSearch={true}
                allowFiltering={false}
              />
              <Template
                name="toolbarAddTemplate"
                render={() => {
                  return (
                    <>
                      <button
                        style={{ cursor: "pointer" }}
                        type="button"
                        title="Add"
                        className="btn btn-primary btn-sm"
                        onClick={async () => {
                          try {
                            setAssetAttachment((prev) => ({
                              ...prev,
                              isSaveAttachmentModalOpen: true,
                            }));
                          } catch (error) {
                            console.log(error);
                          }
                        }}
                      >
                        <i className="fas fa-plus"></i>
                        &nbsp;&nbsp;Add
                      </button>
                    </>
                  );
                }}
              />
              <Template
                name="toolbarRefreshTemplate"
                render={() => {
                  return (
                    <>
                      <button
                        style={{ cursor: "pointer" }}
                        type="button"
                        title="Refresh"
                        className="btn btn-outline-primary btn-sm"
                        onClick={async () => {
                          try {
                            await getAssetAttachmentLst(
                              location?.state?.assetId ?? 0
                            );
                          } catch (error) {
                            console.log(error);
                          }
                        }}
                      >
                        <i className="fas fa-sync-alt"></i>
                        &nbsp;&nbsp;Refresh
                      </button>
                    </>
                  );
                }}
              />
              <Template
                name="toolbarBackTemplate"
                render={() => {
                  return (
                    <>
                      <button
                        style={{ cursor: "pointer" }}
                        type="button"
                        title="Back"
                        className="btn btn-outline-primary btn-sm"
                        onClick={async () => {
                          try {
                            window.location.href = "/asset";
                          } catch (error) {
                            console.log(error);
                          }
                        }}
                      >
                        <i className="fas fa-arrow-left"></i>
                        &nbsp;&nbsp;Back
                      </button>
                    </>
                  );
                }}
              />
              <HeaderFilter visible={false} />
              <SearchPanel
                visible={true}
                highlightCaseSensitive={true}
                width={240}
                placeholder="Search..."
              />
              <Paging defaultPageSize={15} />
              <Pager displayMode="compact" showInfo={true} visible={true} />
              <Export enabled={true} fileName="Asset Attachment" />
            </DataGrid>
          </div>
        </div>
      </div>

      {/* For Adding Multiple Attachment */}
      <Modal
        ariaHideApp={false}
        isOpen={assetAttachment.isSaveAttachmentModalOpen}
        onAfterOpen={async () => {
          await getAssetDocumentCategoryDropdown();
          let err = { ...errors };
          err.documentTypeValidation = "";
          err.fileNameValidation = "";
          err.documentCategoryValidation = "";
          setErrors(err);
        }}
        className={"react-modal custom-modal-xlarge"}
        shouldCloseOnOverlayClick={false}
        contentLabel="Add Asset Attachment"
      >
        <div className="modal-header">
          <h6 className="modal-title">
            {`Add Attachment For Asset [${location?.state?.stateData.name} (${location?.state?.stateData.assetSerial})]`}
          </h6>
          <button
            type="button"
            className="close"
            onClick={() => {
              handleOnCloseAddAssetAttachmentModal();
            }}
          >
            <span aria-hidden="true">x</span>
          </button>
        </div>
        <div className="modal-body">
          <div className="row">
            <div className="col-12 col-lg-3">
              <div className="form-group mb-2">
                <label>
                  Document Category&nbsp;
                  <span className="text-danger">*</span>
                </label>
                <SelectBox
                  dataSource={assetDocumentCategoryDropdown}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  placeholder="Select document category"
                  name="assetDocumentCategoryDropdown"
                  displayExpr="name"
                  valueExpr="id"
                  value={assetAttachment.documentCategoryId}
                  defaultValue={assetAttachment.documentCategoryId}
                  showClearButton={true}
                  disabled={false}
                  searchEnabled={true}
                  onSelectionChanged={async (e) => {
                    let err = { ...errors };
                    err.documentCategoryValidation = "";
                    err.documentTypeValidation = "";
                    setErrors(err);
                    setAssetAttachment((prev) => ({
                      ...prev,
                      documentCategoryId: e?.selectedItem?.id ?? 0,
                      documentCategoryName: e?.selectedItem?.name ?? "",
                      documentTypeId: 0,
                      documentTypeName: "",
                      isIssueDateEnable: false,
                      isExpiryDateEnable: false,
                      isReminderAlertEnable: false,
                      reminderAlertDays: 0,
                      haveDocumentNo: false,
                      isRenewable: false,
                      documentNo: "",
                    }));
                    setAssetDocumentTypeDropdown([]);
                    if (e?.selectedItem?.id > 0) {
                      await getAssetDocumentTypeDropdown(e?.selectedItem?.id);
                    }
                  }}
                />
                {errors.documentCategoryValidation && (
                  <div className="text-danger">
                    {errors.documentCategoryValidation}
                  </div>
                )}
              </div>
            </div>
            <div className="col-12 col-lg-3">
              <div className="form-group mb-2">
                <label>
                  Document Type&nbsp;
                  <span className="text-danger">*</span>
                </label>
                <SelectBox
                  dataSource={assetDocumentTypeDropdown}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  placeholder="Select document type"
                  name="assetDocumentTypeDropdown"
                  displayExpr="documentTypeName"
                  valueExpr="id"
                  value={assetAttachment.documentTypeId}
                  defaultValue={assetAttachment.documentTypeId}
                  showClearButton={true}
                  disabled={false}
                  searchEnabled={true}
                  onSelectionChanged={async (e) => {
                    let err = { ...errors };
                    err.documentTypeValidation = "";
                    setErrors(err);
                    setAssetAttachment((prev) => ({
                      ...prev,
                      documentTypeId: e?.selectedItem?.id ?? 0,
                      documentTypeName: e?.selectedItem?.documentTypeName ?? "",
                      isIssueDateEnable:
                        e?.selectedItem?.isIssueDateAvailable ?? false,
                      isExpiryDateEnable:
                        e?.selectedItem?.isExpiryDateAvailable ?? false,
                      isReminderAlertEnable:
                        e?.selectedItem?.isReminderAlertEnable ?? false,
                      reminderAlertDays:
                        e?.selectedItem?.reminderAlertDefaultDays ?? 0,
                      haveDocumentNo: e?.selectedItem?.haveDocmentNo ?? false,
                      isRenewable: e?.selectedItem?.isRenewable ?? false,
                    }));
                  }}
                />
                {errors.documentTypeValidation && (
                  <div className="text-danger">
                    {errors.documentTypeValidation}
                  </div>
                )}
              </div>
            </div>
            {assetAttachment.haveDocumentNo && (
              <>
                <div className="col-12 col-lg-3">
                  <div className="form-group mb-2">
                    <label>Document No</label>
                    <TextBox
                      className="form-control"
                      placeholder="Enter document no"
                      showClearButton={true}
                      valueChangeEvent="keyup"
                      value={assetAttachment.documentNo}
                      onValueChanged={(e) => {
                        setAssetAttachment((prev) => ({
                          ...prev,
                          documentNo: e?.value,
                        }));
                      }}
                    />
                  </div>
                </div>
              </>
            )}
            {assetAttachment.isIssueDateEnable && (
              <>
                <div className="col-12 col-lg-3">
                  <div className="form-group mb-2">
                    <label>Issue Date</label>
                    <DateBox
                      type="date"
                      className="form-control"
                      name="issueDate"
                      placeholder={DefaultDateFormat.GridDateFormat}
                      displayFormat={DefaultDateFormat.GridDateFormat}
                      showAnalogClock={false}
                      useMaskBehavior={false}
                      defaultValue={assetAttachment.issueDate}
                      value={assetAttachment.issueDate}
                      disabled={false}
                      acceptCustomValue={true}
                      onValueChanged={(date) => {
                        setAssetAttachment((prev) => ({
                          ...prev,
                          issueDate: date.value,
                        }));
                      }}
                    />
                  </div>
                </div>
              </>
            )}
            {assetAttachment.isExpiryDateEnable && (
              <>
                <div className="col-12 col-lg-3">
                  <div className="form-group mb-2">
                    <label>Expiry Date</label>
                    <DateBox
                      type="date"
                      className="form-control"
                      name="expiryDate"
                      placeholder={DefaultDateFormat.GridDateFormat}
                      displayFormat={DefaultDateFormat.GridDateFormat}
                      showAnalogClock={false}
                      useMaskBehavior={false}
                      defaultValue={assetAttachment.expiryDate}
                      value={assetAttachment.expiryDate}
                      disabled={false}
                      acceptCustomValue={true}
                      onValueChanged={(date) => {
                        setAssetAttachment((prev) => ({
                          ...prev,
                          expiryDate: date.value,
                        }));
                      }}
                    />
                  </div>
                </div>
              </>
            )}
            {assetAttachment.isReminderAlertEnable && (
              <>
                <div className="col-12 col-lg-3">
                  <div className="form-group mb-2">
                    <label>Reminder Alert In Days</label>
                    <NumberBox
                      height={38}
                      name="reminderAlertDays"
                      className="form-control"
                      placeholder="Enter reminder alert in days"
                      showClearButton={true}
                      valueChangeEvent="keyup"
                      onValueChanged={(e) => {
                        setAssetAttachment((prev) => ({
                          ...prev,
                          reminderAlertDays: e.value,
                        }));
                      }}
                      value={
                        Number(assetAttachment.reminderAlertDays ?? 0) || ""
                      }
                    />
                  </div>
                </div>
              </>
            )}
            <div className="col-12 col-lg-3">
              <div className="form-group mb-2">
                <label>&nbsp;</label>
                <div className="input-group">
                  <div className="col-lg-12 custom-file">
                    <input
                      type="file"
                      name="fileName"
                      className="custom-file-input"
                      onChange={(e) => {
                        handleOnAssetFileUpload(e);
                      }}
                    />
                    <label
                      style={{ height: "38px" }}
                      className="custom-file-label"
                    >
                      {assetAttachment.fileName
                        ? assetAttachment.fileName
                        : "Choose File"}
                    </label>
                    &nbsp;&nbsp;
                  </div>
                </div>
                {errors.fileNameValidation && (
                  <div className="text-danger">{errors.fileNameValidation}</div>
                )}
              </div>
            </div>
            <div className="col-12 col-lg-3">
              <div className="form-group mb-2">
                <label>Remark</label>
                <TextArea
                  className="form-control"
                  placeholder="Enter remark"
                  showClearButton={true}
                  height={38}
                  valueChangeEvent="keyup"
                  value={assetAttachment.remark}
                  onValueChanged={(e) => {
                    setAssetAttachment((prev) => ({
                      ...prev,
                      remark: e.value,
                    }));
                  }}
                />
              </div>
            </div>
            <div className="col-12 col-lg-3">
              <div className="form-group mb-2">
                <div>&nbsp;</div>
                <button
                  type="button"
                  className="btn btn-primary btn-sm"
                  onClick={async (e) => {
                    await handleOnSaveTemporaryAttachment(e);
                  }}
                  style={{ height: "36px" }}
                  disabled={assetAttachment.isUploaded}
                >
                  <span title="Add">
                    <i
                      className={`fas fa-${
                        assetAttachment.isUploaded ? "spinner fa-spin" : "plus"
                      }`}
                    />
                    &nbsp;&nbsp;Add
                  </span>
                </button>
              </div>
            </div>
          </div>
          <br />
          <hr></hr>
          <br />
          <div className="row">
            <div className="col-12 col-lg-12">
              <div className="form-group mb-2">
                <DataGrid
                  dataSource={assetAttachment.uploadedTemporaryAttachmentLst}
                  showBorders={true}
                  columnAutoWidth={true}
                  allowColumnResizing={true}
                  showRowLines={true}
                  showColumnLines={true}
                  height={300}
                >
                  <Column
                    dataField="noOfRows"
                    caption=""
                    allowSorting={false}
                    allowSearch={false}
                    allowExporting={false}
                    allowFiltering={false}
                    width={25}
                    cellRender={(data) => {
                      if (data?.data?.id === 0) {
                        const idPrefix = `icon-${data?.data?.id}`;
                        return (
                          <IconWithTooltip
                            id={`${idPrefix}-delete`}
                            className="iconify-size mr-1"
                            title="Delete"
                            tooltip="Delete"
                            icon="fluent:delete-32-regular"
                            style={{ cursor: "pointer" }}
                            onClick={(e) => {
                              setAssetAttachment((prev) => ({
                                ...prev,
                                uploadedTemporaryAttachmentLst:
                                  assetAttachment.uploadedTemporaryAttachmentLst?.filter(
                                    (f) => f.noOfRows !== data?.data.noOfRows
                                  ),
                              }));
                            }}
                          />
                        );
                      }
                    }}
                  />
                  <Column
                    dataField="assetFileName"
                    caption="File Name"
                    allowSearch={true}
                  />
                  <Column
                    dataField="fileSize"
                    caption="File Size"
                    allowSearch={true}
                    alignment={"center"}
                  />
                  <Column
                    dataField="fileCategoryName"
                    caption="Document Category"
                    allowSearch={true}
                  />
                  <Column
                    dataField="fileTypeName"
                    caption="Document Type"
                    allowSearch={true}
                  />
                  <Column
                    dataField="fileDocumentNo"
                    caption="Document No"
                    allowSearch={true}
                  />
                  <Column
                    dataField="issueDate"
                    caption="Issue Date"
                    allowSearch={true}
                    dataType="date"
                    format={DefaultDateFormat.GridDateFormat}
                  />
                  <Column
                    dataField="expiryDate"
                    caption="Expiry Date"
                    allowSearch={true}
                    dataType="date"
                    format={DefaultDateFormat.GridDateFormat}
                  />
                  <Column
                    dataField="reminderAlertDays"
                    caption="Reminder Alert In Days"
                    allowSearch={true}
                    alignment={"center"}
                  />
                  <Column
                    dataField="remark"
                    caption="Remark"
                    allowSearch={true}
                  />
                  <HeaderFilter visible={false} />
                  <Scrolling mode="virtual" />
                  <SearchPanel
                    visible={true}
                    highlightCaseSensitive={true}
                    width={240}
                    placeholder="Search..."
                  />
                </DataGrid>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          {assetAttachment.uploadedTemporaryAttachmentLst?.length > 0 && (
            <>
              <button
                type="button"
                className="btn btn-primary btn-sm"
                onClick={async (e) => {
                  await handleOnSubmitAssetAttachment(e);
                }}
                disabled={assetAttachment.isSubmitted}
              >
                <span title="Submit">
                  <i
                    className={`fas fa-${
                      assetAttachment.isSubmitted ? "spinner fa-spin" : "check"
                    }`}
                  />
                  &nbsp;&nbsp;Submit
                </span>
              </button>
              &nbsp;&nbsp;
            </>
          )}
          <button
            type="button"
            className="btn btn-outline-primary btn-sm"
            title="Cancel"
            onClick={() => {
              handleOnCloseAddAssetAttachmentModal();
            }}
          >
            <i className="fas fa-times"></i>&nbsp;&nbsp;Cancel
          </button>
        </div>
      </Modal>
    </>
  );
}
